import {
    Button,
    ModalBody,
    ModalDialog,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from '@flos/react-ui';
import type {
    CoverageDTO,
    TermDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { useHippoText } from '../../hooks/useHippoText';
import {
    getCoverageName,
    getFormattedTermValue,
    getTitleText,
    varyingDeductibleModalTermConfig
} from './configs';

const VaryingDeductableModal = ({
    showModal,
    closeModal,
    coverage,
    deductibleTerms
}: {
    showModal: boolean;
    closeModal: () => void;
    coverage: CoverageDTO;
    deductibleTerms: TermDTO[];
}): React.JSX.Element => {
    const getHippoText = useHippoText();

    const filterTerms = varyingDeductibleModalTermConfig(coverage, deductibleTerms);
    const titleText = getHippoText(getTitleText(coverage));
    const coverageName = getCoverageName(coverage);

    return (
        <ModalOverlay
            isOpen={showModal}
            onDismiss={() => {
                closeModal();
            }}
        >
            <ModalDialog
                closeIconHandler={() => {
                    closeModal();
                }}
            >
                <ModalHeader title={`${titleText} ${coverageName ?? ''}`}>
                    <p className="u-spacing-inset-m--stretch-max u-spacing-stack-none">
                        {getHippoText('DSS-VARYING-DEDUCTIBLE-SUBTITLE')}
                    </p>
                </ModalHeader>
                <ModalBody>
                    {filterTerms.map((term) => {
                        return (
                            <div key={term.name} className="u-flex-box u-flex-box--space-between">
                                <p>{term.name}</p>
                                <p>{getFormattedTermValue(term)}</p>
                            </div>
                        );
                    })}
                </ModalBody>
                <ModalFooter className="u-text-left">
                    <Button
                        onClick={() => {
                            closeModal();
                        }}
                    >
                        {getHippoText('DSS-COMMON-CLOSE')}
                    </Button>
                </ModalFooter>
            </ModalDialog>
        </ModalOverlay>
    );
};

export default VaryingDeductableModal;
